import React from 'react';

import styles from './contract-input.module.scss';

interface IContractInputHeaderItemProps {
  label: string;
  required?: boolean;
  value?: any;
}

export default function ContractStaticHeaderItem({
  label,
  required = false,
  value,
}: IContractInputHeaderItemProps) {
  return (
    <div>
      <div className={styles['ag-contract-input']}>
        <div className={styles.label}>
          {`${label} `}
          {required && <span>*</span>}
        </div>
        <div className={styles['static-placeholder']}>{value}</div>
      </div>
    </div>
  );
}
